const globalMixin = {
    computed: {
        state() {
            return this.$store.state;
        }
    },
    methods: {
        setData(type, val) {
            this.$store.commit('setData', [type, val])
        },
        setDataRad(type, val) {
            this.$store.commit('setDataRad', [type, val])
        },
        getHouse(val) {
            switch (val) {
                case 'habitation-bbc':
                    return 'Habitation neuve'
                case 'habitation-bien-isole':
                    return 'Habitation bien isolée'
                case 'habitation-mal-isole':
                    return 'Habitation mal isolée'
            }
        },
        getRoom(val) {
            switch (val) {
                case 'salle-de-bain':
                    return 'Salle de bain'
                case 'sejour':
                    return 'Séjour'
                case 'chambre':
                    return 'Chambre'
                case 'cuisine':
                    return 'Cuisine'
            }
        },
        the_image(rad) {
            let url = '';
            if (this.state.radiator.orientation == 'horizontal') url += 'H-'
            else url += 'V-'
            url += rad.height + '-';
            if (this.state.radiator.finition == 'Brillant') url += 'ER-';
            else url += 'ST-';
            url += rad.power + '-';
            switch (this.state.radiator.color.name) {
                case 'Beige': {
                    url += 'BE';
                    break;
                }
                case 'Noir': {
                    url += 'N';
                    break;
                }
                case 'Miroir': {
                    url += 'MI';
                    break;
                }
                case 'Blanc reflet vert': {
                    url += 'B';
                    break;
                }
                case 'Gris anthracite': {
                    url += 'GA';
                    break;
                }
                case 'Extra blanc': {
                    url += 'BB';
                    break;
                }
            }
            url += '.png'
            return url;
        }
    }
}
export default globalMixin